// extracted by mini-css-extract-plugin
export default {"header":"styles_header__YU8Zn","title":"styles_title__oTGN5","search":"styles_search__J7Id7","user":"styles_user__0ltHf","dp":"styles_dp__-q+ST"};